import { getToday, setLatestDate } from '../utils';
import { BREAKPOINT_LARGE } from '../variables';
import { log } from './logger';

export default function cartFunctionality() {
  if (!document.body.classList.contains('woocommerce-cart'))
    return;

  addCartQuantityBtns();
  getCartDeliveryPlan();
  setCartDeliveryPlan();
  triggerCartQuantityChange();
  deliveryInfoModal();

  $(document.body).on('updated_cart_totals', function () {
    addCartQuantityBtns();
    getCartDeliveryPlan();
    setCartDeliveryPlan();
  });
}

function addCartQuantityBtns() {
  if ($(document).width() >= BREAKPOINT_LARGE) {
    $('.cart_item .quantity > .qty').attr('type', 'text').parent().append('<span class="increase-product-qty">+</span>').prepend('<span class="decrease-product-qty">-</span>');
    $('.cart_item .quantity > .qty').attr('type', 'text').parent().addClass('wl-children-added');
    addCartQuantityBtnHandlers();
  }
}

export function addCartQuantityBtnHandlers() {
  $('.increase-product-qty').on('mousedown', function (e) {
    e.preventDefault();
    $(this).siblings('input.qty').focus();
    const parent = $(this).parent();
    $('input', parent).val(function(i, oldval) {
      if ($(this).attr('max') && (+oldval + 1) <= $(this).attr('max'))
        ++oldval;
      else if (!$(this).attr('max'))
        ++oldval;

      return oldval;
    }).change();
  });

  $('.decrease-product-qty').on('mousedown', function(e) {
    e.preventDefault();
    const parent = $(this).parent();
    $('input', parent).val(function(i, oldval) {
      if ($(this).attr('min') && oldval - 1 >= $(this).attr('min'))
        --oldval;

      else if (!$(this).attr('min') && oldval > 0)
        --oldval;

      return oldval;
    }).change();
  });
}

function removeArticlesToProceedNoticeIfPresent() {
  const removeArticlesToProceedNotice = document.querySelector('.remove-items-info');
  if (removeArticlesToProceedNotice)
    removeArticlesToProceedNotice.remove();
}

function getCartDeliveryPlan() {
  removeArticlesToProceedNoticeIfPresent();
  if ($('.checkout-delivery-date').length > 0) {
    $('.continue-to-checkout-button').addClass('disabled');
    const articles = [];
    $('.checkout-delivery-date').each(function() {
      $('.calculated-delivery-date span', this).html('<div class="custom-loading-spinner"><img src="/wp-content/themes/artwood/images/loading-spinner.gif" alt="loading spinner"></div>');
      articles.push({ sku: $(this).data('sku'), amount: $(this).data('amount') });
    });
    const data = {
      action: 'get_delivery_plan',
      articles: articles
    };
    $.ajax({
      url: ajax_handler.ajaxurl,
      type: 'post',
      dataType: 'json',
      data: data,
      complete: function(response) {
        let canContinue = true;
        let latestDate = getToday();
        $('.checkout-delivery-date').each(function() {
          const tr = this;
          let found = false;
          $.each(JSON.parse(response.responseText), function(i, article) {
            if (article.levdatum == 'BEST' || article.levdatum == '-ST-')
              latestDate = setLatestDate(latestDate, '');
            else if (article.levdatum)
              latestDate = setLatestDate(latestDate, article.levdatum);
          });
          $.each(JSON.parse(response.responseText), function(i, article) {
            if ($(tr).data('sku') == article.artnr) {
              found = true;
              let remainingAmount = $(tr).data('amount');
              let fetchedAmount = 0;
              let split = '';
              let splitText = '';
              $.each(article.levplan, function(j, levplan) {
                if (remainingAmount > 0 && levplan.amount > fetchedAmount) {
                  if (split.length > 0) {
                    split += ',';
                    splitText += '<br>';
                  }
                  if (levplan.amount - fetchedAmount >= remainingAmount) {
                    split += remainingAmount + '|' + levplan.date;
                    splitText += remainingAmount + ' ' + delPiecesAt + ': ' + ' ' + levplan.date;
                  } else {
                    split += levplan.amount - fetchedAmount + '|' + levplan.date;
                    splitText += levplan.amount - fetchedAmount + ' ' + delPiecesAt + ': ' + ' ' + levplan.date;
                  }
                  remainingAmount -= parseInt(levplan.amount) - parseInt(fetchedAmount);
                  fetchedAmount += parseInt(levplan.amount) - parseInt(fetchedAmount);
                }
              });
              if (article.levdatum == 'BEST' || article.levdatum == '-ST-') {
                if (remainingAmount) {
                  $('.continue-to-checkout-button').before('<span class="remove-items-info">' + removeItemsToContinue + '</span>');
                  $('.delivery-date-choice span span', tr).html(splitText + '<br>' + remainingAmount + ' ' + delPiecesAt + ': ' + delDateContact);
                } else if (splitText.length > 0) {
                  $('.delivery-date-choice span span', tr).html(splitText);
                } else {
                  $('.delivery-date-choice span span', tr).html(delDateNotAvailable);
                }
                canContinue = false;
              } else if (article.levdatum) {
                if (article.levdatum == 'OMG!')
                  article.levdatum = getToday();

                $('.calculated-delivery-date span', tr).html(article.levdatum);
                sessionStorage.setItem('levplan_calculated[' + article.artnr + ']', latestDate);

                // DEBUG
                log(`Setting sessionStorage key ${'levplan_calculated[' + article.artnr + ']'} with value ${article.levdatum}`, 'setItem levplan_calculated');

                if (splitText.length > 0)
                  $('.split-delivery-date span', tr).html(splitText);
                else
                  $('.split-delivery-date span', tr).html(article.levdatum);
                if (split.length < 1) {
                  split = $(tr).data('amount') + '|' + article.levdatum; // Detta är en ledtid (dvs finns ingen levplan)
                }
                sessionStorage.setItem('levplan_split[' + article.artnr + ']', split);

                // DEBUG
                log(`Setting sessionStorage key ${'levplan_split[' + article.artnr + ']'} with value ${split}`, 'setItem levplan_split');

                sessionStorage.setItem('levplan[' + article.artnr + ']', 'calculated-delivery-date');

                // DEBUG
                log(`Setting sessionStorage key ${'levplan[' + article.artnr + ']'} with value ${'calculated-delivery-date'}`, 'setItem levplan_calculated');
              } else {
                if (remainingAmount) {
                  $('.continue-to-checkout-button').before('<span class="remove-items-info">' + removeItemsToContinue + '</span>');
                  $('.delivery-date-choice span span', tr).html(splitText + '<br>' + remainingAmount + ' ' + delPiecesAt + ': ' + delDateContact);
                } else if (splitText.length > 0) {
                  $('.delivery-date-choice span span', tr).html(splitText);
                } else {
                  $('.delivery-date-choice span span', tr).html(delDateNotAvailable);
                }
                canContinue = false;
              }
            }
          });
          if (!found) {
            $('.delivery-date-choice span span', tr).html(delDateNotAvailable);
            canContinue = false;
          }
        });
        if (canContinue) {
          $('.continue-to-checkout-button').removeClass('disabled');
          $('#delivery-times-group-delivery-span').text(latestDate);
        }
        $('.part-delivery-checkbox').trigger('click'); // Sätt delleverans som förvalt alternativ
      }
    });
  }
}

function setCartDeliveryPlan() {
  if ($('.delivery-times-form-part').length == 0)
    return;

  const splitBtn = $('.part-delivery-checkbox');
  const calculatedBtn = $('.calculated-delivery-checkbox');
  calculatedBtn.prop('checked', true);

  splitBtn.click(function(e) {
    if (!calculatedBtn.prop('checked'))
      e.preventDefault();

    calculatedBtn.prop('checked', false);
    sessionStorage.setItem('levplan', 'split-delivery');
    $('.del-option.calculated-delivery-date').hide();
    $('.del-option.split-delivery-date').show();
  });

  calculatedBtn.click(function(e) {
    if (!splitBtn.prop('checked'))
      e.preventDefault();

    splitBtn.prop('checked', false);
    sessionStorage.setItem('levplan', 'calculated-delivery-date');
    $('.del-option.split-delivery-date').hide();
    $('.del-option.calculated-delivery-date').show();
  });

  calculatedBtn.click();
}

function triggerCartQuantityChange() {
  $('.woocommerce').on('blur', 'input.qty', function() {
    $('[name="update_cart"]').trigger('click');
  });
}

function deliveryInfoModal() {
  $('.info-btn').click(function() {
    $('.delivery-info-modal').addClass('showing');
  });

  $('.delivery-info-modal .close-modal-btn').click(function() {
    $('.delivery-info-modal').removeClass('showing');
  });
}
